<template>
  <div class="forecast-playback">
    <button
      class="playback-button"
      :disabled="loading || dates.length < 2"
      :aria-label="playing ? '暂停预报播放' : '播放预报序列'"
      @click="$emit('toggle')"
    >
      <i :class="playing ? 'el-icon-video-pause' : 'el-icon-video-play'"></i>
      {{ playing ? '暂停' : '播放' }}
    </button>
    <div class="playback-track">
      <div class="playback-caption" aria-live="polite">
        <span>{{ loading ? '正在加载最新预报…' : dates.length ? '预报日期：' + dates[index] : '暂无预报数据' }}</span>
        <span v-if="dates.length" class="playback-counter">{{ index + 1 }} / {{ dates.length }}</span>
      </div>
      <input
        class="playback-range"
        type="range"
        min="0"
        :max="Math.max(0, dates.length - 1)"
        step="1"
        :value="index"
        :disabled="loading || dates.length < 2"
        :style="{ '--progress': progress + '%' }"
        aria-label="预报日期进度"
        :aria-valuetext="dates[index] || '暂无预报数据'"
        @input="$emit('seek', Number($event.target.value))"
      >
      <div v-if="dates.length" class="playback-dates">
        <span>{{ dates[0] }}</span>
        <span v-if="dates.length > 1">{{ dates[dates.length - 1] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForecastPlayback',
  props: {
    dates: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    playing: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    progress() {
      return this.dates.length > 1 ? this.index / (this.dates.length - 1) * 100 : 0
    }
  }
}
</script>

<style scoped>
.forecast-playback {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding: 9px 14px;
  color: #d6f4ff;
  background: rgba(0, 20, 40, 0.85);
  border-top: 1px solid rgba(0, 216, 255, 0.2);
}
.playback-button {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 10px;
  color: #00d8ff;
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.4);
  border-radius: 4px;
  white-space: nowrap;
  cursor: pointer;
}
.playback-button i { font-size: 19px; }
.playback-button:disabled { opacity: 0.4; cursor: default; }
.playback-track { flex: 1; min-width: 0; }
.playback-caption, .playback-dates { display: flex; justify-content: space-between; gap: 8px; }
.playback-caption { font-size: 12px; }
.playback-counter, .playback-dates { color: #8aaebd; font-size: 11px; }
.playback-range {
  display: block;
  width: 100%;
  height: 5px;
  margin: 10px 0;
  appearance: none;
  border-radius: 3px;
  background: linear-gradient(to right, #00d8ff var(--progress), #294353 var(--progress));
  cursor: pointer;
}
.playback-range::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #d6faff;
  border: 2px solid #00d8ff;
}
.playback-range::-moz-range-thumb {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #d6faff;
  border: 2px solid #00d8ff;
}
.playback-range:disabled { opacity: 0.4; cursor: default; }
.playback-button:focus-visible, .playback-range:focus-visible { outline: 2px solid #00d8ff; outline-offset: 3px; }
</style>
